import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardHeader } from 'reactstrap';
import Flex from '../common/Flex';
import { Circle } from 'react-es6-progressbar.js';
import { rgbaColor, themeColors } from '../../helpers/utils';

const IndicadorCircular = ({
  total,
  saved,
  title,
  iconButton,
  percOntimeDescarga
}) => {
  const calculateProgressValue = () => {
    if (typeof percOntimeDescarga === 'string') {
      const converted = parseFloat(percOntimeDescarga.replace(',', '.'));
      return !isNaN(converted) ? converted / 100 : 0;
    }
    if (typeof percOntimeDescarga === 'number') {
      return percOntimeDescarga / 100;
    }
    return 0;
  };

  const progressValue = calculateProgressValue();

  const getDisplayPercentage = () => {
    if (typeof percOntimeDescarga === 'string') {
      return percOntimeDescarga;
    }
    if (typeof percOntimeDescarga === 'number') {
      return percOntimeDescarga.toFixed(2).replace('.', ',');
    }
    return '0,00';
  };

  const displayPercentage = getDisplayPercentage();

  const options = {
    color: themeColors.primary,
    strokeWidth: 5,
    trailWidth: 5,
    trailColor: rgbaColor('#000', 0.15),
    easing: 'easeInOut',
    duration: 3000,
    svgStyle: {
      'stroke-linecap': 'round',
      display: 'block',
      width: '100%'
    },
    text: { autoStyleContainer: false },
    step: (state, circle) => {
      circle.path.setAttribute('stroke', themeColors.primary);
    }
  };

  return (
    <Card className="h-100">
      <CardHeader>
        {title} {iconButton}
      </CardHeader>
      <CardBody tag={Flex} align="center" justify="center" className="m-auto">
        <div style={{ position: 'relative' }}>
          <Circle
            progress={progressValue}
            options={options}
            container_class="progress-circle progress-circle-dashboard"
            container_style={{ width: '80%', height: '70%' }}
          />
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              textAlign: 'center'
            }}
          >
            <span
              className="value"
              style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: themeColors.primary
              }}
            >
              {displayPercentage}%
            </span>
          </div>
          <div className="text-center mt-5">
            <h6 className="mb-1">
              Total: {total}
              <br />
              On-time: {saved}
            </h6>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default IndicadorCircular;
